import React from 'react';
import { TutorCard } from './tutor-card.component';
import type { TutorCardsProps } from './show-tutors-on-slot-modal.types';

export const TutorCards = ({ tutors = [], onBookTutor }: TutorCardsProps) => {
  const cards = tutors.map((tutor) => (
    <TutorCard key={tutor.id} tutor={tutor} onBook={onBookTutor} />
  ));

  return <ul className="list-none">{cards}</ul>;
};
